import Logo from '@/assets/logo-madcup.svg'

const isProduction = process.env.VUE_APP_ENVIRONMENT === 'production'

const language = localStorage.getItem('language')
const isSpanish = language === 'es'

export default {
  namespaced: true,
  state: {
    property: isProduction ? 'nUvAD6ZPT75yLctcAuuf' : 'H8xRhCDQ2l4kJsRMm17R',
    subproperty: isProduction ? 'VEIhnN9Fq5qZ9lt6OjYf' : 'UB7JpgfpquzLUKOSB6bU',
    name: 'MadCup',
    pageTitle: {
      en: 'MadCup registration form - OWQLO',
      es: 'Formulario registro MadCup - OWQLO',
    },
    defaultLanguage: 'es',
    logo: Logo,
    ageCategories: [
      {
        id: 'sub19',
        label: isSpanish ? 'Juvenil SUB-19 (2003)' : 'Under 19 (2003)',
        format: 'f11',
        genders: ['female'],
      },
      {
        id: 'sub16',
        label: isSpanish ? 'Cadete SUB-16 (2006)' : 'Under 16 (2006)',
        format: 'f11',
        genders: ['male', 'female'],
      },
      {
        id: 'sub15',
        label: isSpanish ? 'Cadete SUB-15 (2007)' : 'Under 15 (2007)',
        format: 'f11',
        genders: ['male'],
      },
      {
        id: 'sub14',
        label: isSpanish ? 'Infantil SUB-14 (2008)' : 'Under 14 (2008)',
        format: 'f11',
        genders: ['male', 'female'],
      },
      {
        id: 'sub14-f7',
        label: isSpanish ? 'Infantil SUB-14 (2008)' : 'Under 14 (2008)',
        format: 'f7',
        genders: ['female'],
      },
      {
        id: 'sub13',
        label: isSpanish ? 'Infantil SUB-13 (2009)' : 'Under 13 (2009)',
        format: 'f11',
        genders: ['male'],
      },
      {
        id: 'sub12',
        label: isSpanish ? 'Alevín SUB-12 (2010)' : 'Under 12 (2010)',
        format: 'f7',
        genders: ['male', 'female'],
      },
      {
        id: 'sub12-f11',
        label: isSpanish ? 'Alevín SUB-12 (2010)' : 'Under 12 (2010)',
        format: 'f11',
        genders: ['male'],
      },
      {
        id: 'sub11',
        label: isSpanish ? 'Alevín SUB-11 (2011)' : 'Under 11 (2011)',
        format: 'f7',
        genders: ['male'],
      },
      {
        id: 'sub10',
        label: isSpanish ? 'Benjamín SUB-10 (2012)' : 'Under 10 (2012)',
        format: 'f7',
        genders: ['male'],
      },
      {
        id: 'sub9',
        label: isSpanish ? 'Benjamín SUB-9 (2013)' : 'Under 9 (2013)',
        format: 'f7',
        genders: ['male'],
      },
      {
        id: 'sub8',
        label: isSpanish ? 'Prebenjamín SUB-8 (2014)' : 'Under 8 (2014)',
        format: 'f7',
        genders: ['male'],
      },
    ],
  },
}
